import { render } from "./Placeholders.vue?vue&type=template&id=18d0a3d6&scoped=true"
import script from "./Placeholders.vue?vue&type=script&lang=js"
export * from "./Placeholders.vue?vue&type=script&lang=js"

import "./Placeholders.vue?vue&type=style&index=0&id=18d0a3d6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d0a3d6"]])

export default __exports__